import styled from "styled-components";


export const HeaderContainer = styled.div`
display: flex;
justify-content: end;
align-items: center;
height: 3rem;
padding-right: 1rem;

`



export const RowContainer  = styled.div`
display: flex;
justify-content: space-between;
column-gap: 4rem;
width: 100%;
padding-left: 2rem;
padding-right: 2rem;
`